import { apiClient } from "@/api/api-client.ts";
import createBaseService from "@/api/base-service.ts";
import type { Session } from "@/features/dashboard/types/session.ts";
import type { User } from "@/features/dashboard/types/user.ts";

const profileService = {
	...createBaseService<User>("/profile"),
	removeAvatar: async () => {
		await apiClient.delete("/profile/remove_avatar");
	},
	getSessions: async () => {
		const response = await apiClient.get<{ data: Session[] }>(
			"/profile/sessions",
		);

		return response.data;
	},
};

export default profileService;
